import { ChevronsLeftIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

type SidebarToggleProps = {
  showSidebar: boolean;
  toggleSidebar: () => void;
};

const SidebarToggle = ({ showSidebar, toggleSidebar }: SidebarToggleProps) => {
  return (
    <Button
      className={`max-md:hidden group fixed top-[4rem] z-10 h-10 w-10 rounded-full border border-blue-500/55 bg-blue-500/26 text-blue-900 backdrop-blur-lg shadow-[0_10px_28px_rgba(37,99,235,0.3)] ring-1 ring-white/45 transition-all duration-300 hover:scale-105 hover:border-blue-500/70 hover:bg-blue-500/34 hover:text-blue-950 hover:shadow-[0_14px_34px_rgba(37,99,235,0.38)] dark:border-blue-300/35 dark:bg-blue-400/16 dark:text-blue-50 dark:ring-white/10 dark:hover:bg-blue-400/24 dark:hover:text-blue-50 focus-visible:ring-2 focus-visible:ring-blue-300/80 focus-visible:ring-offset-2 active:scale-95 ${!showSidebar ? 'left-[5rem]' : 'left-[calc(4rem+(100vw-4rem)*0.2+1rem)]'}`}
      size="icon"
      variant="outline"
      onClick={toggleSidebar}
      aria-label={showSidebar ? "Collapse sidebar" : "Expand sidebar"}
    >
      <ChevronsLeftIcon
        className={`h-[18px] w-[18px] text-blue-800 transition-all duration-300 group-hover:text-blue-950 dark:text-blue-100 dark:group-hover:text-sky-100 group-active:animate-spin ${!showSidebar ? 'rotate-180' : ''}`}
      />
    </Button>
  );
};

export default SidebarToggle; 